import React, { useEffect } from 'react';
import { CallControls, CallingState, SpeakerLayout, StreamCall, useCalls, useCallStateHooks, RingingCall, useCall } from '@stream-io/video-react-sdk';

const MyIncomingCalls = () => {
    const calls = useCalls();
    // console.log({icalls: calls});

    // handle incoming ring calls
    const incomingCalls = calls.filter(
        (call) => {
            return call.isCreatedByMe === false &&
            call.state.callingState === CallingState.RINGING;
        }
    );

    if (incomingCalls.length < 1) {
        return null;
    }

    const [incomingCall] = incomingCalls;

    if (incomingCall) {
        return (
            <StreamCall call={incomingCall} key={incomingCall.cid}>
                <MyIncomingCall />
            </StreamCall>
        );
    }

    // return incomingCalls.map((call) => (
    //     <StreamCall call={call} key={call.cid}>
    //         <MyIncomingCall />
    //     </StreamCall>
    // ));
};

const MyIncomingCall = () => {
    const call = useCall();
    const { useCallCallingState } = useCallStateHooks();
    const callingState = useCallCallingState();
    // const { endCallByParticipant } = useVideoCallStore();

    // const handleCallLeave = () => {
    //     console.log('Participant Left');
    //     endCallByParticipant();
    // };

    useEffect(() => {
        if (!call) return;
        // const myCall = client.call(callType, callId);
        // myCall.join({ create: true }).then(
        //     () => setCall(myCall),
        //     () => console.error("Failed to join the call"),
        // );
        return () => {
            if (call) {
                call.leave().catch(() => console.error('Failed to leave the incoming call'));
            }
            // setCall(undefined);
        };
    }, [call]);

    if (callingState === CallingState.RINGING) {
        return <div className="call-panel">
            <RingingCall />
        </div>;
    }

    return (
        <>
            {/* https://getstream.io/random_svg/?id=oliver&name=Oliver */}
            {/* <Avatar name="Oliver" imageSrc="https://getstream.io/random_svg/?id=oliver&name=Oliver" /> */}
            <SpeakerLayout />
            {/* <CallControls onLeave={handleCallLeave} /> */}
            <CallControls />
        </>
    );
};

export default MyIncomingCalls;